import { countyMapLayerSelector } from '@/redux/store/slices/map/mapSlice'
import { useAppSelector } from '@redux/hooks/useAppState'
import { Source } from 'react-map-gl/mapbox'

import { StyledMapLabelLayer } from './StyledMapLabelLayer'
import { StyledMapLineLayer } from './StyledMapLineLayer'

const useShowCountyMapLayer = () => {
	const countyLayerVisible = useAppSelector(countyMapLayerSelector)

	return countyLayerVisible
}

export const CountiesMapLayer = ({ beforeId }: { beforeId: { beforeId?: string } }) => {
	const displayCountyLayer = useShowCountyMapLayer()

	if (!displayCountyLayer) {
		return null
	}

	return (
		<Source id="county-boundaries" type="vector" url="mapbox://honeygrid.countiesz5">
			<StyledMapLineLayer id="county-boundaries-line" source-layer="counties" />
			<StyledMapLabelLayer {...beforeId} id="county-labels" source-layer="counties" />
		</Source>
	)
}
